<template>
    <div class="yd-select-project" v-show="show">
        <div class="yd-select-project-title" @click="project.show = true">
            <span>{{project.name}}</span>
            <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
        </div>
        <YD-dialog :show.sync="project.show">
            <div class="yd-select-project-dialog">
                <div class="yd-select-project-content">
                    <ul>
                        <li v-for="(item,index) in projectData" :key="index">
                            <div class="name" v-pressed 
                                v-if="item.Children && item.Children.length > 0" 
                                :class="{'childrenActive':project.activeIndex == index}"
                                @click.stop="selectProject(0,index,item.Id,item.Name,item.Children)"
                            >{{item.Name}}</div>
                            <div class="name" v-pressed 
                                v-else
                                :class="{'active':project.activeIndex == index}"
                                @click.stop="selectProject(0,index,item.Id,item.Name)"
                            >{{item.Name}}</div>
                            <ol
                                v-if="item.Children && item.Children.length > 0" 
                                v-show="project.activeIndex == index"
                            >
                                <li v-pressed 
                                    v-for="(subItem,subIndex) in item.Children" :key="subIndex"
                                    :class="{'active':project.CActiveIndex == subIndex}"
                                    @click.stop="selectProject(1,subIndex,subItem.Id,subItem.Name)"
                                >{{subItem.Name}}</li>
                            </ol>
                        </li>
                    </ul>
                </div>
                <div class="yd-select-project-cancel">
                    <button @click="project.show = false">取消</button>
                </div>
            </div>
        </YD-dialog>
    </div>
</template>
<script>
const _utils = require('@/components/utils');
const Component = _utils.createComponent('select-project');
import Vue from 'vue';
import Dialog from '@/components/Dialog';
Vue.use(Dialog);
export default Component({
    props:{
        'project-data':{
            type:Array,
            required: true,
            default:()=>[]
        },
        Id:{
            type:Number,
            default:-1
        },
        show:Boolean
    },
    data(){
        return {
            project:{
                show:false,
                Id:-1,
                name:'',
                oldIndex: -1,//未点击子选项前标记前一个大项的下标
                COldIndex: -1,//未点击子选项前标记前一个小项
                activeIndex:-1,//父选中
                CActiveIndex:-1,//子选中
            }
        }
    },
    watch:{
        Id:function(newVal){
            if(newVal != this.project.Id){
                this.setProjectActive();
            }
        },
        projectData:function(){
            this.setProjectActive();
            this.$emit('init',this.project.Id);
        },
        'project.show':{
            deep:true,
            handler(newVal){
                if(!newVal){
                    var obj = this.project;
                    if(obj.oldIndex != -1){
                        obj.activeIndex = obj.oldIndex;
                        obj.CActiveIndex = obj.COldIndex;
                        obj.oldIndex = -1;
                        obj.COldIndex = -1;
                    }
                }
            }
        }
    },
    methods:{
        setProjectActive(){
            var arr = this.projectData;
            var obj = this.project;
            if(arr.length > 0){
                var is = true;
                i:
                for(var i=0;i<arr.length;i++){
                    if(arr[i].Children && arr[i].Children.length > 0){
                        let Children = arr[i].Children;
                        for(var j=0;j<Children.length;j++){
                            if(this.Id == Children[j].Id){
                                obj.activeIndex = i;
                                obj.CActiveIndex = j;
                                obj.name = Children[j].Name;
                                obj.Id = Children[j].Id;
                                is = false;
                                break i;
                            }
                        }
                    }else if(this.Id == arr[i].Id){
                        obj.activeIndex = i;
                        obj.CActiveIndex = -1;
                        obj.name = arr[i].Name;
                        obj.Id = arr[i].Id;
                        is = false;
                        break ;
                    }
                }
                if(is){
                    obj.activeIndex = 0;
                    if(arr[0].Children && arr[0].Children.length > 0){
                        obj.CActiveIndex = 0;
                        obj.name = arr[0].Children[0].Name;
                        obj.Id = arr[0].Children[0].Id;
                    }else{
                        obj.CActiveIndex = -1;
                        obj.name = arr[0].Name;
                        obj.Id = arr[0].Id;
                    }
                }
            }
        },
        selectProject(type,index,id,name,children){
            var obj = this.project;
            var isSelect = false;
            if(type == 0){
                if(obj.activeIndex != index){
                    if(children && children.length > 0){
                        obj.oldIndex = obj.activeIndex;
                        obj.COldIndex = obj.CActiveIndex;
                    }else{
                        isSelect = true;
                    }
                    obj.activeIndex = index;
                    obj.CActiveIndex = -1;
                }
            }else{
                obj.CActiveIndex = index;
                isSelect = true;
            }
            if(isSelect){
                obj.name = name;
                obj.Id = id;
                obj.oldIndex = -1;
                obj.COldIndex = -1;
                obj.show = false;
                this.$emit('change',id)
            }
        }
    }
})
</script>
<style lang="scss">
.yd-select-project{
    .yd-select-project-title{
        width: auto;
        height: 50px;
        font-size: 36px;
        color: #1B1C1E;
        font-weight: 500;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 32px;
            height: 32px;
            margin-left: 4px;
            margin-top: 1px;
        }
    }
}
.yd-select-project-dialog{
    height: 910px;
    width: 100%;
    padding-top: 56px;
    box-sizing: border-box;
    .yd-select-project-content{
        width: 100%;
        height: 676px;
        overflow-y: auto;
        ul{
            height: auto;
            >li{
                height: auto;
            }
            .name{
                @include line-height(104px);
                width: 100%;
                font-size: 28px;
                color: #1B1C1E;
                text-align: center;
                font-weight: 400;
                &.active{
                    color: #7AD21A;
                    font-weight: 500;
                }
                &.childrenActive{
                    font-weight: 500;
                }
            }
            ol{
                padding-bottom: 16px;
                >li{
                    @include line-height(72px);
                    width: 100%;
                    font-size: 28px;
                    color: #8B8C8D;
                    text-align: center;
                    font-weight: 400;
                    &.active{
                        color: #7AD21A;
                        font-weight: 500;
                    }
                }
            }
        }
    }
}
.yd-select-project-cancel{
    height: 264px;
    width: 100%;
    padding-top: 62px;
    box-sizing: border-box;
    button{
        width: 520px;
        @include line-height(108px);
        background: #1B1C1E;
        border-radius: 54px;
        font-size: 32px;
        color: #FFFFFF;
        font-weight: 500;
        display: block;
        margin: 0 auto;
    }
}
</style>